<script>
	import analyticsUtilities from 'utilities/analyticsUtilities';
	import OutboundLink from 'components/outbound-link.vue';

	export default {
		components: {
			'outbound-link': OutboundLink
		},
		methods: {
			onSignUpButtonClick() {
				analyticsUtilities.fireEvent(analyticsUtilities.events.HOMEPAGE_CLICK, {
					loc: 'SIGN_UP_CTA'
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';
	@import 'config/colors';

	.cta-panel {
		text-align: center;
		color: $c-white;
		margin: 3rem 0;

		.cta-wrapper {
			padding: 3rem 1rem 4rem;
			border-radius: 5rem;
			background-color: $c-blue-accent-1;
		}

		h2 {
			margin: 1rem 0;
		}

		.button {
			min-height: 2.5rem;
			padding: 0.375rem 1rem;
			display: inline-flex;
			justify-content: center;
			align-items: center;

			@include media(med) {
				min-height: 3rem;
			}
		}

		.sign-up-button-container {
			margin: 2rem 0;

			@include media(med) {
				margin: 3rem 0 2rem;
			}
		}

		.sign-up-button {
			font-size: 1.125rem;
			background-color: $c-white;
			color: $c-blue-accent-2;

			&:hover {
				background-color: $c-blue-accent-2;
				color: $c-white;
				border-color: $c-white;
			}

			@include media(med) {
				font-size: 1.25rem;
			}
		}

		.secondary-button-container {
			display: flex;
			justify-content: center;
			flex-wrap: wrap;
		}

		.secondary-button {
			flex: 0 1 22rem;
			margin: 0.5rem 0;
			color: $c-white;
			border-color: $c-white;
			background-color: transparent;

			&:hover {
				color: $c-blue-accent-2;
				background-color: $c-white;
			}

			@include media(med) {
				flex-basis: 19rem;

				&:first-child {
					margin-right: 1rem;
				}
			}
		}
	}
</style>
<template>
	<section class="cta-panel">
		<div class="wrapper">
			<div class="cta-wrapper">
				<h2>Sign Up Today!</h2>
				<p class="panel-content">Get FREE, science-backed content, tools, and resources</p>
				<div class="sign-up-button-container">
					<a
						href="/teacher-signup"
						class="button sign-up-button"
						@click="onSignUpButtonClick"
						>Sign Up</a
					>
				</div>
				<div class="secondary-button-container">
					<outbound-link
						href="https://about.readworks.org/newsletter.html"
						class="button -outline secondary-button"
						data-outbound-link="NEWSLETTER_SIGN_UP"
						>Subscribe to our newsletter</outbound-link
					>
					<outbound-link
						href="https://about.readworks.org/districts.html"
						class="button -outline secondary-button"
						data-outbound-link="RW_FOR_DISTRICTS"
						>Learn more about district programs</outbound-link
					>
				</div>
			</div>
		</div>
	</section>
</template>
